import axios from "axios"
import { router } from "../../../routes"

const API_URL=process.env.VUE_APP_API;

const moduleLogin={
    state:()=>({
        token: "",
        name: "",
        surname: "",
        id: "",
        isAdmin:false,
        ga: false,
        isAccountStatus: false,
        isPasswordReset : false
    }),
    mutations:{
        setToken(state, token) {
            state.token = token
        },
        setAccountStatus(state, status) {
            state.isAccountStatus = status
        },
        setResetPassword(state, isChanged) {
            state.isPasswordReset = isChanged
        },
        setName(state, name) {
            state.name = name
        },
        setSurname(state, surname) {
            state.surname = surname
        },
        setId(state, id) {
            state.id = id
        },
        setIsAdmin(state,_isAdmin){
            state.isAdmin=_isAdmin;
        },      
        setGa(state, ga) {
            state.ga = ga
        },
        clearToken(state) {
            state.token = ""
        },
        clearAccountStatus(state) {
            state.isAccountStatus = false
        },
        clearPasswordResetStatus(state) {
            state.isPasswordReset = false
        },
        clearGa(state) {
            state.ga = false
        },
    },
    actions:{
        login({ commit, dispatch, state }, authData) {

            return axios.post(`${API_URL}/login/singin`,
                { username: authData.username, password: authData.password, ipAddress: authData.ipAddress}
            ).then(response => {             
                if(response.data === 5)
                {
                    commit("setMessage", "Hesabınız bloke edildi lütfen yönetici ile iletişime geçin!")
                    toastr.error("Hesabınız bloke edildi lütfen yönetici ile iletişime geçin!");                
                }
                else if(response.data.changePassword === true)
                {
                    commit("setAccountStatus", response.data.changePassword)
                    commit("setId", response.data.id)
                }
                else
                {
                commit("setToken", response.data.token)
                commit("setName", response.data.name)
                commit("setSurname", response.data.surname)
                commit("setId", response.data.id)
                commit("setIsAdmin",response.data.isAdmin);
                localStorage.setItem("token", response.data.token)
                localStorage.setItem("id", response.data.id)
                localStorage.setItem("name", response.data.name)
                localStorage.setItem("surname", response.data.surname)
                localStorage.setItem("isAdmin",response.data.isAdmin)
                }
          

                //dispatch("setTimeoutTimer", 3600000)
            },
                (err) => {
                    if (err.response.status == 401) {
                        commit("setMessage", "Kullanıcı Adı veya Şifre Hatalı!")
                        toastr.error("Kullanıcı Adı veya Şifre Hatalı!");
                    }
                    else{
                        commit("setMessage", err.response.data.Message);
                        toastr.error(err.response.data.Message);
                    }
                })
        },
        resetPassword({ commit, dispatch, state }, authData) {

            return axios.post(`${API_URL}/login/ResetPassword`,// reset-password
                { UserResetId: authData.UserResetId, newPassword: authData.newPassword }
            ).then(response => {
                if(response.data === true)
                { 
                    commit("setResetPassword", true);
                    toastr.success("Hesap Sıfırlama başarıyla!");
                    
                }   
            },
                (err) => {
                    commit("setMessage", "Kullanıcı bulunamadı!")
                    toastr.error("Kullanıcı bulunamadı!");
                })
        },
        ga({ commit, dispatch, state }, authData) {

            return axios.post(`${API_URL}/login/ga`,
                { token: state.token, ga: authData.ga }
            ).then(response => {
                commit("setGa", true)
                localStorage.setItem("ga", true)

                dispatch("sites", { id: localStorage.getItem("id"), token: state.token })
                dispatch("modules", { id: localStorage.getItem("id"), token: state.token })

            },
                (err) => {
                    commit("setMessage", "Ga Kodunuz Hatalı!")

                    toastr.error("Ga Kodunuz Hatalı!");
                })
        },
        logout({ commit }) {
            commit("clearToken")
            commit("clearGa")
            localStorage.removeItem("token")
            localStorage.removeItem("ga")
            router.replace("/login")
        },
        reset({ commit }) {
            commit("clearAccountStatus")
            commit("clearPasswordResetStatus")                 
        },
    },
    getters:{
        isAuthenticated(state) {
            return state.token !== "" && state.token !== null
        },
        getAccountStatus(state) {
            return state.isAccountStatus
        },
        getPasswordResetStatus(state) {
            return state.isPasswordReset
        },
        isGa(state) {
            return state.ga
        },
        getNameSurname(state) {
            return state.name + " " + state.surname
        },
   
        getToken(state) {
            return state.token
        },
        getId(state) {
            return state.id
        },
        getIsAdmin(state){
            return state.isAdmin
        }
    }
}

export default moduleLogin;


// WEBPACK FOOTER //
// ./src/store/Modules/login/index.js